export * from './lib/patient-web-feature-shell.module';
export * from './lib/shared';
export * from './lib/account-registration/containers/duplicate-registration-verify-identity/duplicate-registration-verify-identity.component';
export * from './lib/account-registration/containers/duplicate-registration-mfa-setup/duplicate-registration-mfa-setup.component';
export { braintree } from './braintree.d';
